import { render, staticRenderFns } from "./OzPadletLogo.vue?vue&type=template&id=7d61c5cf&scoped=true&"
import script from "./OzPadletLogo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzPadletLogo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzPadletLogo.vue?vue&type=style&index=0&id=7d61c5cf&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d61c5cf",
  null
  
)

export default component.exports